import React from "react";
import Box from "@amzn/meridian/box";
import SearchField from "@amzn/meridian/search-field";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Toggle from "@amzn/meridian/toggle";
import { FilterValues } from "../filterOptions";
import { FILTER_GROUPS, FilterGroup } from "../FilterGroup";

interface SearchAndFiltersProps {
    searchQuery: string;
    handleSearch: (query: string) => void;
    handleSearchSubmit: () => void;
    showAddedOnly: boolean;
    handleToggleChange: (checked: boolean) => void;
    filterValues: FilterValues;
    handleFilterChange: (filterKey: string) => (value: string) => void;
}

export const SearchAndFilters: React.FC<SearchAndFiltersProps> = ({
    searchQuery,
    handleSearch,
    handleSearchSubmit,
    showAddedOnly,
    handleToggleChange,
    filterValues,
    handleFilterChange,
}) => {
    return (
        <Box width="71rem" spacingInset={"0 600 0 0"}>
            <SearchField
                width={"35rem"}
                value={searchQuery}
                onChange={handleSearch}
                placeholder="Search by address, city or ZIP code"
                onSubmit={handleSearchSubmit}
                searchButton={true}
            />

            <Box height="20px" />

            <Row alignmentHorizontal={"justify"} spacingInset={"200 0 200 0"}>
                <Text type={"h200"}>Search result</Text>
                <Row>
                    <Toggle checked={showAddedOnly} onChange={handleToggleChange} />
                    <Text>Show added comps</Text>
                </Row>
            </Row>

            <Box height="20px" />

            <Row alignmentHorizontal={"justify"}>
                <FilterGroup
                    filters={FILTER_GROUPS.MAIN_FILTERS}
                    values={filterValues}
                    onChange={handleFilterChange}
                    disabled={showAddedOnly}
                />
                <FilterGroup
                    filters={[FILTER_GROUPS.ORDER_FILTER]}
                    values={filterValues}
                    onChange={handleFilterChange}
                    alignment="end"
                />
            </Row>
        </Box>
    );
};
